module.exports = __webpack_public_path__ + "static/img/jd5.aa9496ca.png";